import { render, staticRenderFns } from "./PortalNotifications.vue?vue&type=template&id=69db0a30&"
import script from "./PortalNotifications.vue?vue&type=script&lang=ts&"
export * from "./PortalNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports